<template>
  <div id="plan">

    <!-- intro -->
    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />
        <h2>Wat staat in dit beleggingsplan?</h2>
        <p>
          Dit document is om twee redenen belangrijk. De eerste reden is dat hierin uw persoonlijke
          informatie is vastgelegd. Uw persoonlijke informatie is opgesteld aan de hand van de
          antwoorden die u op onze vragen heeft gegeven. De tweede reden is dat in dit document
          wordt beschreven hoe wij uw geld gaan beleggen. Deze informatie betreft onder andere uw
          financiële positie, uw risicobereidheid, uw beleggingsdoelstelling en uw kennis en
          ervaring op beleggingsgebied.
        </p>

        <h2>Lees dit document goed en laat het ons weten als er iets niet klopt</h2>
        <p>
          Het is belangrijk dat u ons wijst op dingen die fout of niet volledig in dit
          beleggingsplan staan. Verandert er iets in uw persoonlijke omstandigheden? Of verwacht u
          dat er iets verandert? En klopt daardoor de informatie over uw persoonlijke omstandigheden
          die wij van u hebben gekregen niet meer? Dan moet u ons dat zo snel mogelijk laten weten.
          Dan beoordelen wij of we het beleggingsplan moeten veranderen. Doet u dit niet of te laat?
          Dan zijn wij niet verantwoordelijk voor de gevolgen.
        </p>
        <p>
          Stel, u gaat scheiden. Dan kan dat betekenen dat het beleggingsplan moet veranderen. Geeft
          u niet aan ons door dat u gaat scheiden? Dan kan het zo zijn dat de beleggingen die wij
          doen niet meer passen bij uw nieuwe persoonlijke omstandigheden en u bijvoorbeeld een
          beleggingsverlies niet meer kunt dragen.
        </p>

        <h2>Informatievoorziening</h2>
        <p>
          Wij houden u op de hoogte en communiceren met u via onze website, uw eigen online omgeving
          en via e-mail. Soms nemen we contact met u op via telefoon of sturen wij u een bericht via
          de post. Iedere maand krijgt u een overzicht met de waardeontwikkeling en de wijze
          waarop uw portefeuille is samengesteld aan het einde van deze periode. Ook vindt u hierin
          alle beleggingen die wij hebben gekocht en verkocht en ziet u of en hoe uw portefeuille is
          veranderd. Tevens staat in dit overzicht vermeld welke kosten u waarvoor heeft betaald.
        </p>
        <p>
          Indien u vragen of opmerkingen heeft, neem dan contact met ons op via
          <b>020 - 555 0055</b> of ons e-mailadres <b>info@doelbeleggen.nl</b>
        </p>
        <p>
          Doelbeleggen is een handelsnaam van Velthuyse · Mulder Vermogensbeheer B.V., ingeschreven
          in het handelsregister te Amsterdam onder nummer 34.120.836 met BTW nummer
          NL8082.63.559.B01 en rekeningnummer IBAN NL85 ABNA 0551 6791 58. Doelbeleggen is
          geregistreerd als beleggingsonderneming met een vergunning van de Autoriteit Financiële
          Markten op grond van de Wet op het Financieel Toezicht onder nummer 12008646.
        </p>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- rekeninghouders -->
    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />

        <h2 style="margin-bottom:1em;">Rekeninghouder(s)</h2>
        <table
          v-if="intake.rekeningData.type == 'Bedrijfsrekening'"
          style="table-layout:fixed;" class="new"
        >
          <tr>
            <td colspan="4">
              <b>{{ intake.bedrijfsData.bedrijfsnaam || "Bedrijfsnaam" }}</b>
            </td>
          </tr>
          <tr>
            <td>Straatnaam, Huisnummer</td>
            <td>
              <b
                >{{ intake.bedrijfsData.straat }} {{ intake.bedrijfsData.huisnummer }}
                {{ intake.bedrijfsData.toevoeging }}</b
              >
            </td>
            <td>Lei-nummer</td>
            <td>
              <b>{{ intake.bedrijfsData.lei }}</b>
            </td>
          </tr>
          <tr>
            <td>Postcode, Woonplaats</td>
            <td>
              <b>{{ intake.bedrijfsData.postcode }} {{ intake.bedrijfsData.plaats }}</b>
            </td>
            <td>RSIN-nummer</td>
            <td>
              <b>{{ intake.bedrijfsData.rsin }}</b>
            </td>
          </tr>
          <tr>
            <td>Land</td>
            <td>
              <b>{{ intake.bedrijfsData.land }}</b>
            </td>
            <td>Rechtsvorm</td>
            <td>
              <b>{{
                intake.bedrijfsData.rechtsvorm === 'anders'
                ? intake.bedrijfsData.rechtsvormAnders
                : intake.bedrijfsData.rechtsvorm
              }}</b>
            </td>
          </tr>
          <tr>
            <td>Tegenrekening</td>
            <td>
              <b>{{ intake.rekeningData.iban || "Tegenrekening" }}</b>
            </td>
            <td>KVK-nummer</td>
            <td>
              <b>{{ intake.bedrijfsData.kvk }}</b>
            </td>
          </tr>
        </table>

        <table v-if="intake.financeData.negatiefVermorgen == 'Yes'" class="new">
          <tr>
            <td>
              Het bedrijf heeft een negatief eigen vermogen. Het vermogen dat Doelbeleggen voor u
              gaat beheren, in combinatie met het overige vermogen binnen de B.V., is dan wellicht
              onvoldoende voor de volledige dekking van de voorziening in de B.V.. Dit kan invloed
              hebben op de haalbaarheid van eventuele toekomstige betalingen. Wanneer u hier nog
              niet met uw accountant over heeft gesproken, adviseren wij u alsnog contact met hem
              of haar op te nemen.
            </td>
          </tr>
          <tr v-if="intake.financeData.uitgeleend == 'Yes'">
            <td>
              Het bedrijf heeft geld uitgeleend
              <template v-if="intake.financeData.uitgeleendU == 'Yes'">
                aan persoon zelf.
              </template>
              <template v-else>
                een prive persoon.
              </template>
            </td>
          </tr>
        </table>

        <table
          v-for="(persoon, index) in filter(intake.persoonsData, deathFilter)"
          :key="`r${index}naam`"
          style="table-layout:fixed;" class="new"
        >
          <tr style="background-color:#eee">
            <th colspan="2">
              <b>
                {{ persoon.type }} - {{ persoon.voorletters }}
                <template v-if="!persoon.voorletters">Voornaam</template>
                {{ persoon.tussenvoegsel }} {{ persoon.achternaam }}
                <template v-if="!persoon.achternaam">Achternaam</template>
                <template v-if="persoon.voornaam">({{ persoon.voornaam }})</template>
              </b>
            </th>
          </tr>
          <tr>
            <td>
              Straatnaam, Huisnummer
              <b>
                {{
                  persoon.zelfdeAdres == "Yes" ? intake.persoonsData[0].straat : persoon.straat
                }}
                {{
                  persoon.zelfdeAdres == "Yes"
                    ? intake.persoonsData[0].huisnummer
                    : persoon.huisnummer
                }}
                {{
                  persoon.zelfdeAdres == "Yes"
                    ? intake.persoonsData[0].toevoeging
                    : persoon.toevoeging
                }}
              </b>
            </td>
            <td>
              Telefoonnummer
              <b>{{ persoon.telefoonnummer }}</b>
            </td>
          </tr>
          <tr>
            <td>
              Postcode, Woonplaats
              <b>
                {{
                  persoon.zelfdeAdres == "Yes"
                    ? intake.persoonsData[0].postcode
                    : persoon.postcode
                }}
                {{
                  persoon.zelfdeAdres == "Yes" ? intake.persoonsData[0].plaats : persoon.plaats
                }}
              </b>
            </td>
            <td>
              E-mail <b v-if="index == 0">{{ $parent.$parent.$parent.email }}</b
              ><b v-else>{{ persoon.email }}</b>
            </td>
          </tr>
          <tr>
            <td>
              Land
              <b>{{
                persoon.zelfdeAdres == "Yes" ? intake.persoonsData[0].land : persoon.land
              }}</b>
            </td>
            <td>
              BSN
              <b>{{ persoon.bsn }}</b>
            </td>
          </tr>
          <tr>
            <td>
              Geboortedatum
              <b>{{ new Date(persoon.geboorteDatum).toLocaleDateString() }}</b>
            </td>
            <td>
              Nationaliteit
              <b>{{ persoon.nationaliteit }}</b>
            </td>
          </tr>
          <tr>
            <td>
              Geboorteplaats <b>{{ persoon.geboortplaats }} ({{ persoon.geboorteland }})</b>
            </td>
            <td>
              <template v-if="index == 0 && intake.rekeningData.type != 'Bedrijfsrekening'">
                Tegenrekening <b>{{ intake.rekeningData.iban}}</b>
              </template>
            </td>
          </tr>
        </table>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- fin. situatie -->
    <div class="card" :key="`r${index}naam`" v-for="(persoon, index) in filter(
      filter(intake.persoonsData, financeFilter),
      deathFilter,
    )">
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />

        <h2>
          Financiële situatie
          {{ persoon.voorletters }}
          <span v-if="!persoon.voorletters">Voornaam</span>
          {{ persoon.tussenvoegsel }}
          {{ persoon.achternaam }}
          ({{ persoon.type }})
        </h2>

        <p>
          Hieronder staat de informatie die u aan ons heeft gegeven, indien belangrijke informatie
          ontbreekt dan vragen wij u dat aan ons door te geven. Wij kunnen namelijk bij ons
          vermogensbeheer geen rekening houden met informatie die wij niet weten.
        </p>

        <p v-if="persoon.levensonderhoud && persoon.levensonderhoud.substr(0, 2) == 'ja'">
          Wij hebben verder begrepen dat uw inkomsten uit arbeid en/of ander vermogen ruimschoots
          toereikend zijn om in uw levensonderhoud, pensioen en financiële verplichtingen te
          voorzien.
        </p>

        <table class="new">
          <tr>
            <th>
              <b>Inkomen</b>
            </th>
          </tr>
          <tr>
            <td>
              U ontvangt inkomen
              <template v-if="persoon.inkomenType == 'Loondienst'">uit loondienst.</template>
              <template
                v-if="persoon.inkomenType == 'Zelfstandige'
                  || persoon.inkomentype == 'Eenmanszaak'
                "
              >
                als zelfstandige.
              </template>
              <template v-if="persoon.inkomenType == 'Pensioen'">
                uit AOW en/of werkgeverspensioen.
              </template>
              <template v-if="persoon.inkomenType == 'Anders'">
                uit een andere bron, namelijk {{ persoon.inkomenTypeAnders }}.
              </template>
            </td>
          </tr>
          <tr v-if="persoon.inkomenType != 'Pensioen'">
            <td>
              Uw bruto inkomen is &euro;
              {{ formatPrice(Number(persoon.jaarinkomen || 0), true) }},- per jaar.
            </td>
          </tr>
          <tr v-if="persoon.anderInkomen == 'Yes'">
            <td>
              U heeft extra inkomen uit {{ persoon.anderInkomenType === 'Anders'
                ? persoon.anderInkomenTypeOmschrijving
                : persoon.anderInkomenType }} en is &euro;
              {{ formatPrice(Number(persoon.anderInkomenPerJaar || 0), true) }},- per jaar.
            </td>
          </tr>
          <tr>
            <td>
              <template v-if="persoon.levensonderhoud == 'ja, en kan sparen'">
                Uw inkomsten zijn voldoende voor uw
                {{goalType === 'uitkerend' ? 'vaste uitgavepatroon' : 'levensonderhoud'}}
                en u kunt nog &euro;
                {{ formatPrice(Number(persoon.kanSparenBedrag || 0), true) }},- per maand sparen.
              </template>
              <template v-if="persoon.levensonderhoud == 'ja, en ik kan sparen'">
                Uw inkomsten zijn voldoende voor uw
                {{goalType === 'uitkerend' ? 'vaste uitgavepatroon' : 'levensonderhoud'}}
                en u kunt nog &euro; {{ formatPrice(Number(persoon.kanSparenBedrag || 0), true) }},-
                per maand sparen.
              </template>
              <template v-if="persoon.levensonderhoud == 'ja, voldoende'">
                Uw inkomsten zijn voldoende voor uw
                {{goalType === 'uitkerend' ? 'vaste uitgavepatroon' : 'levensonderhoud'}}.
              </template>
              <template v-if="persoon.levensonderhoud == 'nee, vanuit deze rekening'">
                Uw inkomsten zijn onvoldoende voor uw
                {{goalType === 'uitkerend' ? 'vaste uitgavepatroon' : 'levensonderhoud'}}, u heeft
                &euro;{{ formatPrice(Number(persoon.levensonderhoudBedragPerJaar || 0), true) }},-
                nodig van uw Doelbeleggen rekening.
              </template>
              <template v-if="persoon.levensonderhoud == 'nee, vanuit andere rekening'">
                Uw inkomsten zijn onvoldoende voor uw levensonderhoud, u heeft geld nodig van een
                rekening elders.
              </template>
            </td>
          </tr>
          <tr v-if="goalType === 'uitkerend' && persoon.manierVanLeven">
            <td v-if="persoon.levensonderhoud === 'nee, vanuit deze rekening'">
              Uw manier van leven kan {{ persoon.manierVanLeven === 'No' ? 'niet' : '' }} aangepast
              worden om voldoende inkomsten te hebben als de inkomsten van deze
              {{ intakeAdmin.beleggen.brand }} rekening lager worden of wegvallen.
            </td>
            <td v-else>
              Uw manier van leven
                {{ persoon.manierVanLeven === 'No'
                  ? 'moet aangepast'
                  : 'hoeft niet aangepast te'
                }} worden als de inkomsten van deze {{ intakeAdmin.beleggen.brand }} rekening lager
              worden of wegvallen.
            </td>
          </tr>
        </table>

        <table class="new">
          <tr>
            <th>
              <b>Bruto pensioen</b>
            </th>
          </tr>
          <tr v-if="persoon.inkomenType == 'Pensioen'">
            <td>
              Uw AOW, inclusief eventueel werkgeverspensioen, is &euro;
              {{ formatPrice(Number(persoon.pensioen || 0), true) }},- per jaar.<br />
            </td>
          </tr>
          <tr>
            <td>
              Uw schatting aanvullend pensioen (box 1) is in totaal &euro;
              {{ formatPrice(Number(
                  persoon.pensioenHeeftAanvullend == 'Yes' ? persoon.pensioenAanvullend || 0 : 0
                ), true) }},-
              per jaar.
            </td>
          </tr>
          <tr v-if="persoon.persioenBeheer == 'Yes'">
            <td>U heeft pensioen opgebouwd binnen {{ persoon.pensioenBeheerBV }}.</td>
          </tr>
          <tr>
            <td>
              <template v-if="persoon.pensioenToereikend == 'No'"
                >U heeft aangegeven dat dit pensioen niet toereikend is.</template
              >
              <template v-else>U heeft aangegeven dat uw pensioen toereikend is.</template>
            </td>
          </tr>
        </table>

        <table class="new">
          <tr>
            <th>
              <b>Bezittingen</b>
            </th>
          </tr>
          <tr v-if="persoon.spaarrekening == 'Yes'">
            <td>
              Op uw betaal/spaarrekening(en) heeft u totaal &euro;
              {{
                formatPrice(
                  Number(persoon.spaarrekeningBedrag || 0) +
                    Number(persoon.spaarrekeningBedrag2 || 0) +
                    Number(persoon.spaarrekeningBedrag3 || 0),
                  true
                )
              }},-
            </td>
          </tr>
          <tr v-if="persoon.beleggingen == 'Yes'">
            <td>
              Aan beleggingen heeft u totaal &euro;
              {{
                formatPrice(
                  Number(persoon.beleggingenBedrag || 0) +
                    Number(persoon.beleggingenMeerBedrag || 0) +
                    Number(persoon.beleggingenNogMeerBedrag || 0),
                  true
                )
              }},-
            </td>
          </tr>
          <tr v-if="persoon.eigenwoning == 'Yes'">
            <td>
              De vrije verkoopwaarde van uw eigen woning is &euro;
              {{ formatPrice(Number(persoon.eigenwoningVrijeverkoopwaarde || 0), true) }},-
            </td>
          </tr>
          <tr v-if="persoon.onroerendgoed == 'Yes'">
            <td>
              De vrije verkoopwaarde van overig onroerende goed is &euro;
              {{ formatPrice(Number(persoon.onroerendgoedVrijeverkoopwaarde || 0), true) }},-
              <template v-if="persoon.onroerendgoedCommercieel === 'Yes'
                && persoon.onroerendgoedBedragPerJaar"
              >
                met een jaarlijks inkomen van &euro; {{
                formatPrice(Number(persoon.onroerendgoedBedragPerJaar), true)
                }},-
                <template v-if="persoon.onroerendgoedObjecten">
                  voor {{persoon.onroerendgoedObjecten}}
                  {{persoon.onroerendgoedObjecten == 1 ? 'object.' : 'objecten.'}}
                </template>
              </template>
            </td>
          </tr>
          <tr
            v-if="
              persoon.spaarrekening != 'Yes' &&
                persoon.beleggingen != 'Yes' &&
                persoon.eigenwoning != 'Yes' &&
                persoon.onroerendgoed != 'Yes'
            "
          >
            <td>U heeft geen bezittingen.</td>
          </tr>
        </table>

        <p style="font-style:italic">
          Wij adviseren om altijd een gedeelte van uw vermogen te sparen. Sparen is geen beleggen.
          Beleggen kent grotere risico’s dan sparen.
        </p>

        <table v-if="persoon.eigenwoning != 'Yes'" class="new">
          <tr>
            <th>
              <b>Huurlasten</b>
            </th>
          </tr>
          <tr>
            <td>
              U betaalt aan huur &euro; {{ formatPrice(Number(persoon.huurlasten) || 0, true) }},-
              per maand.
            </td>
          </tr>
        </table>

        <table v-if="persoon.hypotheekEigenWoning == 'Yes'" class="new">
          <tr>
            <th>
              <b>Hypotheek eigen woning</b>
            </th>
          </tr>
          <tr>
            <td v-if="persoon.hypotheekEigenWoningRenteType == 'vast'">
              Hypotheek ({{ persoon.hypotheekEigenWoningType }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoningWaarde || 0), true) }},- met een
              rente van {{ formatPrice(persoon.hypotheekEigenWoningRente / 100) }}% (<em
                >{{ persoon.hypotheekEigenWoningRenteType }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekEigenWoningLooptijd).toLocaleDateString() }}.
            </td>
            <td v-else>
              Hypotheek ({{ persoon.hypotheekEigenWoningType }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoningWaarde || 0), true) }},- met een
              {{ persoon.hypotheekEigenWoningRenteType }}e rente.
            </td>
          </tr>
          <tr v-if="persoon.hypotheekEigenWoning2 == 'Yes'">
            <td v-if="persoon.hypotheekEigenWoning2RenteType == 'vast'">
              Hypotheek ({{ persoon.hypotheekEigenWoning2Type }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoning2Waarde || 0), true) }},- met een
              rente van {{ formatPrice(persoon.hypotheekEigenWoning2Rente / 100) }}%
              (<em>{{ persoon.hypotheekEigenWoningRenteType }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekEigenWoning2Looptijd).toLocaleDateString() }}.
            </td>
            <td v-else>
              Hypotheek ({{ persoon.hypotheekEigenWoning2Type }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoning2Waarde || 0), true) }},- met een
              {{ persoon.hypotheekEigenWoning2RenteType }}e rente.
            </td>
          </tr>
          <tr v-if="persoon.hypotheekEigenWoning3 == 'Yes'">
            <td v-if="persoon.hypotheekEigenWoning3RenteType == 'vast'">
              Hypotheek ({{ persoon.hypotheekEigenWoning3Type }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoning3Waarde || 0), true) }},- met een
              rente van {{ formatPrice(persoon.hypotheekEigenWoning3Rente / 100) }}%
              (<em>{{ persoon.hypotheekEigenWoningRenteType }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekEigenWoning3Looptijd).toLocaleDateString() }}.
            </td>
            <td v-else>
              Hypotheek ({{ persoon.hypotheekEigenWoning3Type }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoning3Waarde || 0), true) }},- met een
              {{ persoon.hypotheekEigenWoning3RenteType }}e rente.
            </td>
          </tr>
        </table>

        <table v-if="persoon.hypotheekOnroerendGoed == 'Yes'" class="new">
          <tr>
            <th>
              <b>Hypotheek overig onroerend goed</b>
            </th>
          </tr>
          <tr>
            <td>
              Hypotheek ({{ persoon.hypotheekOnroerendGoedType }}) op overig onroerend goed van
              &euro; {{ formatPrice(Number(persoon.hypotheekOnroerendGoedWaarde || 0), true) }},-
              met een rente van
              {{ formatPrice(persoon.hypotheekOnroerendGoedRente / 100) }}% (<em>{{
                persoon.hypotheekOnroerendGoedRenteType
              }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekOnroerendGoedLooptijd).toLocaleDateString() }}.
            </td>
          </tr>
          <tr v-if="persoon.hypotheekOnroerendGoed2 == 'Yes'">
            <td>
              Hypotheek ({{ persoon.hypotheekOnroerendGoed2Type }}) op overig onroerend van &euro;
              {{ formatPrice(Number(persoon.hypotheekOnroerendGoed2Waarde || 0), true) }},- met
              een rente van
              {{ formatPrice(persoon.hypotheekOnroerendGoed2Rente / 100) }}% (<em>{{
                persoon.hypotheekOnroerendGoed2RenteType
              }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekOnroerendGoed2Looptijd).toLocaleDateString() }}.
            </td>
          </tr>
          <tr v-if="persoon.hypotheekOnroerendGoed3 == 'Yes'">
            <td>
              Hypotheek ({{ persoon.hypotheekOnroerendGoed3Type }}) op overig onroerend van &euro;
              {{ formatPrice(Number(persoon.hypotheekOnroerendGoed3Waarde || 0), true) }},- met
              een rente van
              {{ formatPrice(persoon.hypotheekOnroerendGoed3Rente / 100) }}% (<em>{{
                persoon.hypotheekOnroerendGoed3RenteType
              }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekOnroerendGoed3Looptijd).toLocaleDateString() }}.
            </td>
          </tr>
        </table>

        <table v-if="persoon.schulden == 'Yes'" class="new">
          <tr>
            <th><b>Overige verplichtingen</b></th>
          </tr>
          <tr>
            <td>
              U heeft een {{ persoon.schuldenType }} van &euro;
              {{ formatPrice(Number(persoon.schuldenBedrag || 0), true) }},- of per maand &euro;
              {{ formatPrice(Number(persoon.schuldenMaandelijks), true) }},-.
            </td>
          </tr>
          <tr v-if="persoon.schuldenMeer == 'Yes'">
            <td>
              U heeft een {{ persoon.schuldenMeerType }} van &euro;
              {{ formatPrice(Number(persoon.schuldenMeerBedrag || 0), true) }},- of per maand
              &euro; {{ formatPrice(Number(persoon.schuldenMeerMaandelijks), true) }},-.
            </td>
          </tr>
          <tr v-if="persoon.schuldenMeer2 == 'Yes'">
            <td>
              U heeft een {{ persoon.schuldenMeer2Type }} van &euro;
              {{ formatPrice(Number(persoon.schuldenMeer2Bedrag || 0), true) }},- of per maand
              &euro; {{ formatPrice(Number(persoon.schuldenMeer2Maandelijks), true) }},-.
            </td>
          </tr>
          <tr v-if="persoon.schuldenMeer3 == 'Yes'">
            <td>
              U heeft een {{ persoon.schuldenMeer3Type }} van &euro;
              {{ formatPrice(Number(persoon.schuldenMeer3Bedrag || 0), true) }},- of per maand
              &euro; {{ formatPrice(Number(persoon.schuldenMeer3Maandelijks), true) }},-.
            </td>
          </tr>
        </table>

        <p style="font-style:italic" v-if="'schulden'">
          Let op, beleg niet met geleend geld. Los eerst uw schulden af.
        </p>
        <p style="font-style:italic" v-else>
          U heeft of verwacht geen periodieke financiële verplichtingen waarmee wij rekening
          moeten houden.
        </p>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- gezamenlijke situatie -->
    <div
      class="card"
      v-if="filter(filter(intake.persoonsData, financeFilter), deathFilter).length > 1"
    >
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />

        <h2>
          Gezamenlijke financiële situatie
        </h2>
        <p>
          Hieronder staat de informatie die u aan ons heeft gegeven, indien belangrijke informatie
          ontbreekt dan vragen wij u dat aan ons door te geven. Wij kunnen namelijk bij ons
          vermogensbeheer geen rekening houden met informatie die wij niet weten.
        </p>

        <table class="new">
          <tr>
            <th>
              <b>Inkomen</b>
            </th>
          </tr>
          <tr>
            <td>
              Bruto jaarinkomen &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), o => Number(o.jaarinkomen || 0)),
                  true
                )
              }},-.
            </td>
          </tr>
          <tr>
            <td>
              Sparen &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), o => Number(o.kanSparenBedrag || 0)),
                  true
                )
              }},- per maand.
            </td>
          </tr>
        </table>

        <table class="new">
          <tr>
            <th>
              <b>Pensioen</b>
            </th>
          </tr>
          <tr
            v-if="
              sumBy(
                filter(
                  filter(intake.persoonsData, financeFilter),
                  deathFilter,
                ),
                o => Number(o.pensioen || 0),
              )
            "
            >
            <td>
              Werkgeverspensioen &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(
                      filter(intake.persoonsData, financeFilter),
                      deathFilter,
                    ),
                    o => Number(o.pensioen || 0)
                  ),
                  true,
                )
              }},-
            </td>
          </tr>
          <tr>
            <td>
              Schatting aanvullend pensioen (box 1) &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), o => Number(o.pensioenAanvullend || 0)),
                  true
                )
              }},-
            </td>
          </tr>
        </table>

        <table class="new">
          <tr>
            <th colspan="2">
              <b>Bezittingen</b>
            </th>
          </tr>
          <tr>
            <td>
              Betaal/spaarrekeningen &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(filter(intake.persoonsData, financeFilter), deathFilter),
                    o =>
                      Number(o.spaarrekeningBedrag || 0) +
                      Number(o.spaarrekeningBedrag2 || 0) +
                      Number(o.spaarrekeningBedrag3 || 0)
                  ),
                  true
                )
              }},-
            </td>
          </tr>
          <tr>
            <td>
              Beleggingen &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(filter(intake.persoonsData, financeFilter), deathFilter),
                    o =>
                      Number(o.beleggingenBedrag || 0) +
                      Number(o.beleggingenMeerBedrag || 0) +
                      Number(o.beleggingenNogMeerBedrag || 0)
                  ),
                  true
                )
              }},-
            </td>
          </tr>
          <tr>
            <td colspan="2">
              Woning(en) &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), o => Number(o.eigenwoningVrijeverkoopwaarde || 0)),
                  true
                )
              }},-
            </td>
          </tr>
          <tr>
            <td colspan="2">
              Overig onroerend goed &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), o => Number(o.onroerendgoedVrijeverkoopwaarde || 0)),
                  true
                )
              }},-
            </td>
          </tr>
        </table>

        <p style="font-style:italic">
          Wij adviseren om altijd een gedeelte van uw vermogen te sparen. Sparen is geen beleggen.
          Beleggen kent grotere risico’s dan sparen.
        </p>

        <table class="new">
          <tr>
            <th>
              <b>Verplichtingen</b>
            </th>
          </tr>
          <tr>
            <td>
              Huur per maand &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), o => Number(o.huurlasten || 0)),
                  true
                )
              }},-
            </td>
          </tr>
          <tr>
            <td>
              Totale hypotheekschuld eigen woning &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(filter(intake.persoonsData, financeFilter), deathFilter),
                    o =>
                      Number(o.hypotheekEigenWoningWaarde || 0) +
                      Number(o.hypotheekEigenWoning2Waarde || 0) +
                      Number(o.hypotheekEigenWoning3Waarde || 0)
                  ),
                  true
                )
              }},-
            </td>
          </tr>
          <tr>
            <td>
              Totale hypotheekschuld onroerend goed &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(filter(intake.persoonsData, financeFilter), deathFilter),
                    o =>
                      Number(o.hypotheekOnroerendGoedWaarde || 0) +
                      Number(o.hypotheekOnroerendGoed2Waarde || 0) +
                      Number(o.hypotheekOnroerendGoed3Waarde || 0)
                  ),
                  true
                )
              }},-
            </td>
          </tr>
          <tr>
            <td>
              Totale overige verplichtingen &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(filter(intake.persoonsData, financeFilter), deathFilter),
                    o =>
                      Number(o.schuldenBedrag || 0) +
                      Number(o.schuldenMeerBedrag || 0) +
                      Number(o.schuldenMeer2Bedrag || 0) +
                      Number(o.schuldenMeer3Bedrag || 0)
                  ),
                  true
                )
              }},-
            </td>
          </tr>

          <tr></tr>
          <tr>
            <td>
              Overige verplichting per maand &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(filter(intake.persoonsData, financeFilter), deathFilter),
                    o =>
                      Number(o.schuldenMaandelijks || 0) +
                      Number(o.schuldenMeerMaandelijks || 0) +
                      Number(o.schuldenMeer2Maandelijks || 0) +
                      Number(o.schuldenMeer3Maandelijks || 0)
                  ),
                  true
                )
              }},-
            </td>
          </tr>
        </table>

        <p style="font-style:italic" v-if="'schulden'">
          Let op, beleg niet met geleend geld. Los eerst uw schulden af.
        </p>
        <p style="font-style:italic" v-else>
          U heeft of verwacht geen periodieke financiële verplichtingen waarmee wij rekening moeten
          houden.
        </p>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- doelstelling -->
    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />
        <h2>Doelstelling</h2>
        <p>
          Per doel geldt een apart beleggingsbeleid en een aparte rekening zodat u precies ziet
          welke beleggingen voor welke doel bestemd zijn. Uw doelstelling is
          <b>{{ typeToGoal }}</b
          >.
        </p>

        <table class="new"
          v-if="
            ((intake.goalData.type == 'levensonderhoud' && intake.goalData.box == '1')
            || intake.goalData.type == 'gouden-handdruk-uitkerend'
            || intake.goalData.type == 'netto-lijfrente-uitkerend')
            && !offerSelected
          "
        >
          <tr><td>
            Uw uitkering is gestart. Wilt u de gegevens inzien, neem dan contact met ons op.
          </td></tr>
        </table>
        <table v-else class="new">
          <tr
            v-if="!offerSelected && redo === 1"
          >
            <td>
              Uw doel is {{ typeToGoal }}, met een portefeuille waarde van
              &euro;&nbsp;{{ formatPrice(Number(portValue > -1 ? portValue : 0), true) }},- en een
              extra inleg van &euro;&nbsp;{{
                formatPrice(Number(intake.goalData.vermogen || 0), true)
              }},-
            </td>
          </tr>
          <tr v-else>
            <td>
              Uw doel is {{ typeToGoal }} en u start met &euro;
              {{ formatPrice(Number(intake.goalData.vermogen || 0), true) }},-
            </td>
          </tr>
          <tr
            v-if="
              intake.goalData.type != 'levensonderhoud' &&
                intake.goalData.type != 'gouden-handdruk-uitkerend' &&
                intake.goalData.type != 'netto-lijfrente-uitkerend'
            "
          >
            <td>
              U heeft daarvoor een doelvermogen opgegeven van &euro;
              {{ formatPrice(Number(intake.goalData.doel || 0), true) }},-
            </td>
          </tr>
          <tr>
            <td v-if="intake.goalData.targetDate">
              U kunt tot {{ new Date(intake.goalData.targetDate).toLocaleDateString() }} beleggen om
              uw doel te realiseren.
            </td>
            <td v-else>
              U kunt {{ intake.goalData.looptijd }} jaar beleggen om uw doel te realiseren.
            </td>
          </tr>
          <tr>
            <th>
              <b>Stortingen &amp; onttrekkingen</b>
            </th>
          </tr>
          <tr
            v-if="
              intake.goalData.type != 'levensonderhoud'
              && intake.goalData.type != 'gouden-handdruk-uitkerend'
              && intake.goalData.type != 'netto-lijfrente-uitkerend'
            "
          >
            <td>
                U gaat
                <span style="text-transform:lowercase">{{
                  intake.goalData.stortingenInterval
                }}</span>
                &euro; {{ formatPrice(Number(intake.goalData.stortingenBedrag || 0), true) }},-
                bijstorten.
            </td>
          </tr>
          <tr
            v-if="
              intake.goalData.type != 'levensonderhoud'
              && intake.goalData.type != 'gouden-handdruk-uitkerend'
              && intake.goalData.type != 'netto-lijfrente-uitkerend'
            "
          >
            <td>
              <template v-if="intake.goalData.onttrekkingen == 'Yes'">
                U gaat
                <span style="text-transform:lowercase">{{
                  intake.goalData.onttrekkingenInterval
                }}</span>
                &euro; {{ formatPrice(Number(intake.goalData.onttrekkingenBedrag || 0), true) }},-
                onttrekken.
              </template>
              <template v-else>U heeft aangegeven niet periodiek te gaan onttrekken.</template>
            </td>
          </tr>
          <tr
            v-if="
              intake.goalData.type == 'levensonderhoud'
              || intake.goalData.type == 'gouden-handdruk-uitkerend'
              || intake.goalData.type == 'netto-lijfrente-uitkerend'
            "
          >
            <td>
              U gaat {{ intake.goalData.stortingenInterval.toLowerCase() }}
              &euro; {{ formatPrice(Number(intake.goalData.doelAanvulling || 0), true) }},-
              onttrekken (&euro; {{ formatPrice(Number(intake.goalData.doelAanvulling || 0)
              * paymentTerms, true) }},- per jaar).
            </td>
          </tr>
        </table>

        <p style="font-style:italic">
          U begrijpt dat de kans bestaat dat uw doelstelling aan het einde van de looptijd niet
          wordt gehaald. U heeft aangegeven dat u het risico van het niet halen van uw doelstelling
          accepteert.
        </p>
        <h2>Haalbaarheid</h2>
        <div class="row">
          <div style="float:left; width:55%;">
            <p>
              Uw haalbaarheid wordt berekend met uw doelgegevens. Maar ook ingrediënten als
              rendement en risico worden gebruikt. De haalbaarheid geeft vanzelf aan wanneer de
              verhouding tussen de ontwikkeling van de beleggingen, het risico en/of de looptijd het
              halen van het doel in gevaar brengt, of juist vergroot. Wat telt is de hoogte van de
              haalbaarheid.
            </p>
            <p>
              Uw persoonlijke verhouding tussen risico, rendement en looptijd wordt voor u dagelijks
              bijgewerkt en inzichtelijk gemaakt via de haalbaarheid. U kunt deze inzien door in te
              loggen in uw persoonlijke omgeving op Doelbeleggen.
            </p>
          </div>
          <div class="box" style="float:right; margin-top:0px; width:20%;">
            <scoreWidget v-model="intake.goalData.score" :showNotice="false" />
          </div>
        </div>
        <p style="margin-top:0;">
          Afhankelijk van uw doel, zal de haalbaarheid zich op eigen wijze ontwikkelen. De
          haalbaarheid van uw doel is geen vast gegeven. Ook de haalbaarheid zal met schommelingen
          op de beurs en het verlopen van tijd bewegen.
        </p>
        <p>
          U kunt aan de hoogte van het haalbaarheidspercentage een aantal zaken zien. Hoe hoger het
          percentage, hoe haalbaarder uw doel. Een haalbaarheid van minder dan 50% geeft aan dat het
          halen van uw doel onzekerder wordt. Met een haalbaarheid van 50% en hoger bouwt u een
          buffer op die van dienst kan zijn wanneer het een keer wat minder gaat op de beurs.
        </p>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- kennis -->
    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />

        <h2>Risicobereidheid</h2>
        <p>
          Aan beleggen zijn risico’s verbonden. Deze risico’s proberen wij zo goed mogelijk voor u
          te beheersen. Wij kunnen deze echter nooit voorzien of voorkomen. Algemeen geldt dat
          naarmate een hoger rendement wordt nagestreefd, de risico’s toenemen. Deze risico’s
          resulteren niet alleen in de mogelijkheid dat het verwachte of beoogde doelvermogen niet
          wordt behaald, maar ook in mogelijke tussentijdse of uiteindelijke verliezen. Zelfs als
          over een langere periode wordt belegd, kan beleggen verlies opleveren. U heeft aangegeven
          deze risico’s te aanvaarden en te accepteren.
        </p>
        <p>
          Het kan zijn dat de waarde van uw beleggingen sneller of verder daalt dan u verwacht. Dat
          heeft ook effect op de hoogte van uw haalbaarheid. U heeft aangegeven dat u bij een daling
          van uw haalbaarheid onder een door u aangegeven waarde bericht van ons wenst. Dit is uw
          alertwaarde die u online kunt vinden. Bij een daling onder uw alertwaarde zullen wij u
          hierover informeren. U kunt deze waarde nadat u bent gestart wijzigen.
        </p>

        <h2>
          Kennis en ervaring
          {{ intake.persoonsData[0].voorletters }}
          {{ intake.persoonsData[0].tussenvoegsel }}
          {{ intake.persoonsData[0].achternaam }}
        </h2>
        <p>
          Uw hoogst genoten opleiding valt binnen {{ intake.experienceData.opleiding }}.
          <template
            v-if="financeFilter(intake.persoonsData[0])
            && intake.persoonsData[0].inkomenType !== 'Anders'"
          >
            U
            <template
              v-if="
                intake.persoonsData[0].inkomenType == 'Werkzoekende' ||
                  intake.persoonsData[0].inkomenType == 'Geen'
              "
            >
              was
            </template>
            <template v-else-if="intake.persoonsData[0].inkomenType == 'Pensioen'">
              bent met pensioen en was
            </template>
            <template v-else>
              bent momenteel
            </template>
            werkzaam als {{ intake.persoonsData[0].beroep }}.
          </template>
          Samenvattend kan worden gesteld dat u een
          <template v-if="intake.experienceData.ervaring != 'Yes'">
            onervaren belegger bent en nauwelijks kennis op het gebied van beleggen heeft.
          </template>
          <template v-else>
            <template
              v-if="
                intake.experienceData.ervaringAandelenWanneer == 'meer dan 5 jaar geleden' ||
                  intake.experienceData.ervaringTrackersWanneer == 'meer dan 5 jaar geleden' ||
                  intake.experienceData.ervaringObligatiesWanneer == 'meer dan 5 jaar geleden' ||
                  intake.experienceData.ervaringOptiesWanneer == 'meer dan 5 jaar geleden'
              "
            >
              ervaren belegger bent en een ruime kennis op het gebied van beleggen heeft.
            </template>
            <template v-else>
              belegger bent met enige beleggingskennis.
            </template>
          </template>
          Uw kennis en ervaring wordt als leidend gezien voor deze rekening. U heeft aangegeven het
          document <em>'risico's &amp; kenmerken van effecten'</em> te hebben gelezen en begrepen.
        </p>

        <p>
          In essentie komt vermogensbeheer erop neer dat wij voor u beleggingsbeslissingen nemen.
          Dat betekent dat wij zonder uw voorafgaande toestemming, beslissen waarin belegd wordt en
          wat er wordt verkocht. Uiteraard doen we dat niet zomaar. Wij maken van tevoren afspraken
          met u over de wijze waarop wij voor u gaan beleggen. Het is uiteindelijk uw geld. Deze
          afspraken hebben we vastgelegd in dit document.
        </p>

        <h2>Duurzaamheidsvoorkeuren</h2>
        <p v-if="intake.rekeningData.sustainabilityPreference">
          Aan de hand van de vragen over o.a. uw financiële situatie en uw risicobereidheid wordt uw
          risicoprofiel vastgesteld. Na deze vragen hebben we u uitleg gegeven over
          duurzaamheidsvoorkeuren. Vervolgens hebben wij aan u de vraag gesteld of u op dit moment
          duurzaamheidsvoorkeuren heeft. Hierop heeft u
          <b>{{ intake.rekeningData.sustainabilityPreference === 'Yes' ? `"ja"` : `"nee"`}}</b>
          geantwoord.
        </p>
        <template v-else-if="intake.rekeningData.sustainability">
          <p v-if="intake.rekeningData.sustainability === 'A'">
            Wij bevestigen dat u akkoord gaat dat uw portefeuille aansluit op uw risicoprofiel maar
            niet op duurzaamheidsvoorkeuren. Daarmee geeft u aan dat voor u onze totale
            dienstverlening voorgaat op  het beleggen met duurzaamheidsvoorkeuren.
          </p>
          <p v-else-if="intake.rekeningData.sustainability === 'B'">
            Wij bevestigen dat u akkoord gaat dat uw portefeuille is samengesteld zonder
            duurzaamheidsvoorkeuren.
          </p>
          <p v-else>
            Wij bevestigen dat u akkoord gaat dat uw portefeuille is samengesteld zonder
            duurzaamheidsvoorkeuren. U heeft ons laten weten dat voor u onze totale
            dienstverlening voorgaat op  het beleggen met duurzaamheidsvoorkeuren.
          </p>
        </template>
        <p v-else>
          <span v-if="sustainabilityPopup === 'A'">
            U heeft aangegeven dat u geen duurzaamheidsvoorkeuren heeft.
          </span>
          <span v-else-if="sustainabilityPopup === 'B'">
            U heeft aangegeven dat u duurzaamheidsvoorkeuren heeft maar dat die niet specifiek zijn.
          </span>
          <span v-else-if="sustainabilityPopup === 'C'">
            U heeft aangegeven dat u specifieke duurzaamheidsvoorkeuren heeft.
          </span>
          Wij bieden een portefeuille
          die ecologische en/of sociale kenmerken promoot. De kenmerken die in de portefeuille
          van ons worden gepromoot zijn een gezondere leefomgeving. Wij sluiten overtreders van de
          UN Global Compact Principes uit en beleggen niet in de productie van tabak.
          <span v-if="sustainabilityPopup === 'B'">
            Hiermee wordt aan uw duurzaamheidsvoorkeuren voldaan.
          </span>
          <span v-else-if="sustainabilityPopup === 'C'">
            U heeft de aanvraag ondanks dat niet aan uw duurzaamheidsvoorkeuren wordt
            voldaan aan ons verzonden. Hiermee heeft u uw duurzaamheidsvoorkeuren aangepast.
          </span>
        </p>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- beleggingsbeleid -->
    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />
        <h2>Samenstelling portefeuille</h2>
        <p>
          Met het concreet maken van uw doel is de basis gelegd voor uw beleggingsprofiel. De
          doelcriteria bestaan uit uw startwaarde, periodieke inleg, looptijd en het gewenste
          doelbedrag. Dit maakt het mogelijk de haalbaarheid per profiel te berekenen. Doelbeleggen
          werkt met 5 verschillende profielen en bijbehorende beleggingsportefeuilles. Iedere
          portefeuille heeft een eigen profiel met zijn eigen beleggingskarakter en haalbaarheid. Na
          inschrijven is uw persoonlijke situatie in kaart gebracht door het beantwoorden van uw
          vragenlijst. Hieruit werd duidelijk wat u aan risico kunt en wenst te dragen en wat uw
          persoonlijke maximale risicoprofiel is.
        </p><br />
        <p>
          Op basis van uw risicoprofiel, uw wensen en doelstellingen hebben wij voor u een
          beleggingsprofiel vastgesteld. U kunt binnen de mogelijkheden van A tot en met E, maximaal
          <b>beleggen via {{ intakeAdmin.beleggen.maxProfile }}</b
          >. Doelbeleggen zoekt binnen dit risicoplafond naar het beleid met de hoogste
          haalbaarheid; uw optimale beleggingsbeleid. Op dit moment is
          <b>beleggingsbeleid {{ intakeAdmin.beleggen.profile }}</b> voor u optimaal, uw
          portefeuille wordt bij aanvang op deze wijze ingericht. U accepteert dit als het voor u te
          voeren beleggingsbeleid. Doelbeleggen houdt uw optimale beleggingsbeleid voor u in de
          gaten en zal waar nodig uw beleggingen aanpassen.
        </p><br />

        <div class="scroll-container">
          <table
            :class="[
              intakeAdmin.beleggen.maxProfile
                ? 'maxprofile-' + intakeAdmin.beleggen.maxProfile.replace(/\s/g, '')
                : '',
              intakeAdmin.beleggen.profile
                ? 'profile-' + intakeAdmin.beleggen.profile.replace(/\s/g, '')
                : '',
              'new'
            ]"
          >
            <tr>
              <td style="width:150px;">Beleggingsbeleid</td>
              <td>A</td>
              <td>B</td>
              <td>C</td>
              <td>D</td>
              <td>E</td>
            </tr>
            <tr>
              <td>Aandelen</td>
              <td>15%</td>
              <td>35%</td>
              <td>50%</td>
              <td>65%</td>
              <td>85%</td>
            </tr>
            <tr>
              <td>Vastgoed</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
            </tr>
            <tr>
              <td>Obligaties</td>
              <td>75%</td>
              <td>55%</td>
              <td>40%</td>
              <td>25%</td>
              <td>5%</td>
            </tr>
            <tr>
              <td>Geldmarkt</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
            </tr>
          </table>
        </div><br />
        Bij het berekenen van de scenario’s en haalbaarheid wordt tevens rekening gehouden met het
        zogenaamde Lifecycle effect.
        <p v-if="intakeAdmin.beleggen.lifecycleDisabled !== 'Yes'">
          Lifecycle betekent dat Doelbeleggen richting het eind van de looptijd het maximale
          risicoprofiel binnen de portefeuilles afbouwt. Het risico afbouwen wordt gerealiseerd door
          uw risicoplafond richting het eind van de looptijd te verlagen. Het is in bepaalde
          situaties mogelijk om de Lifecycle uit te zetten. Wilt u de Lifecycle uitzetten? Neem dan
          contact met ons via 020-555 0055 of info@doelbeleggen.nl.
        </p>
        <p v-else>
          <b>U heeft bij het beleggen gekozen om de Lifecycle uit te schakelen.</b>
          Daarmee zal het maximale risicoprofiel richting de doeldatum van uw Doel niet
          worden afgebouwd. Het kan zijn dat u daardoor met een hoger risico belegd blijft en wordt
          de kans groter dat opgebouwd vermogen meer in waarde afneemt dicht bij de doeldatum. U
          begrijpt en accepteert dit risico, en heeft voldoende financiële middelen om eventuele
          tegenvallers op te vangen. Wilt u de Lifecycle weer aanzetten? Neem dan contact met ons
          via 020-555 0055 of info@doelbeleggen.nl.
        </p>
        <p>
          Door marktomstandigheden kan de verdeling van uw portefeuille afwijken van de
          oorspronkelijke beleggingsmix. Periodiek wordt gecontroleerd of deze afwijking binnen de
          hierboven beschreven grenzen blijft. Wanneer nodig zullen deze afwijkingen worden
          hersteld, dit heet herbalanceren.
        </p>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />

        <p>
          De risicowijzer die bij uw maximale beleggingsbeleid hoort vindt u hieronder. Deze geeft
          de beweeglijkheid (volatiliteit) aan van de beleggingen. Dit wil zeggen de hoogte en
          frequentie van de koersschommelingen van uw beleggingen indien deze zouden zijn
          samengesteld conform <b>beleggingsbeleid {{ intakeAdmin.beleggen.maxProfile }}</b
          >.
        </p><br />

        <table class="new">
          <tr>
            <td style="padding:0; width:70%;">
              <GChart
                v-if="$parent.$parent.planToggle && pieRows"
                :settings="{ packages: ['corechart'], language: 'nl-nl' }"
                :data="[columns1].concat(pieRows)"
                :options="options1"
                type="PieChart"
              />
            </td>
            <th style="text-align:center;">
              <img
                v-if="this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen A'"
                src="../../assets/risk/risicometer2.3-3.3.svg"
              />
              <img
                v-if="this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen B'"
                src="../../assets/risk/risicometer2.6-4.0.svg"
              />
              <img
                v-if="this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen C'"
                src="../../assets/risk/risicometer3.0-4.3.svg"
              />
              <img
                v-if="this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen D'"
                src="../../assets/risk/risicometer3.6-4.6.svg"
              />
              <img
                v-if="this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen E'"
                src="../../assets/risk/risicometer4.0-5.0.svg"
              />
            </th>
          </tr>
        </table><br />

        <p>
          U ziet hieronder een overzicht van de waardeontwikkeling, tussentijdse
          waardenschommelingen en kansen op verlies over een 5-jaars, 10-jaars en 20-jaars periode.
          Wij nemen als startpunt € 10.000,-.
        </p>
        <p>
          Historische ontwikkelingen, macro-economische uitgangspunten en rendement- en
          risicoverwachtingen vormen de basis voor de vermogensverwachting. De verschillende
          scenario's zijn te zien als mogelijke vermogensontwikkelingen in de toekomst. Hiermee
          kunnen de gevolgen van diverse economische ontwikkelingen voor uw rendement en
          haalbaarheid inzichtelijk worden gemaakt. In de vermogensverwachting ziet u informatie
          over een slechte-, normale en goede markt van het voor u geselecteerde maximale
          beleggingsbeleid. Ondanks dat wij de prognoses en verwachtingen baseren op betrouwbaar
          geachte (statistische) uitgangspunten, is er geen garantie dat uw doelstelling
          daadwerkelijk behaald wordt.
        </p>

        <h2>Waardeontwikkeling</h2>

        <table
          v-if="intakeAdmin.beleggen.maxProfile === 'Doelbeleggen A'"
          class="transparent-table"
        >
          <tr>
            <th>{{ intakeAdmin.beleggen.maxProfile }}</th>
            <th>5 jaar</th>
            <th>10 jaar</th>
            <th>20 jaar</th>
          </tr>
          <tr :style="`color: ${tableColors[2]}`">
            <td>Goede markt</td>
            <td>&euro; 15.253 (52,5%)</td>
            <td>&euro; 20.799 (108%)</td>
            <td>&euro; 37.667 (277%)</td>
          </tr>
          <tr :style="`color: ${tableColors[1]}`">
            <td>Normale markt</td>
            <td>&euro; 11.856 (18,6%)</td>
            <td>&euro; 14.565 (45,6%)</td>
            <td>&euro; 22.758 (128%)</td>
          </tr>
          <tr :style="`color: ${tableColors[0]};`">
            <td>Slechte markt</td>
            <td>&euro; 9.216 (-7,84%)</td>
            <td>&euro; 10.199 (1,99%)</td>
            <td>&euro; 13.750 (37,5%)</td>
          </tr>
          <tr>
            <td style="width:150px">Kans op negatief rendement</td>
            <td>13,3%</td>
            <td>4,13%</td>
            <td>0,36%</td>
          </tr>
        </table>

        <table
          v-if="intakeAdmin.beleggen.maxProfile === 'Doelbeleggen B'"
          class="transparent-table"
        >
          <tr>
            <th>{{ intakeAdmin.beleggen.maxProfile }}</th>
            <th>5 jaar</th>
            <th>10 jaar</th>
            <th>20 jaar</th>
          </tr>
          <tr :style="`color: ${tableColors[2]}`">
            <td>Goede markt</td>
            <td>&euro; 17.088 (70,9%)</td>
            <td>&euro; 24.810 (148%)</td>
            <td>&euro; 49.619 (396%)</td>
          </tr>
          <tr :style="`color: ${tableColors[1]}`">
            <td>Normale markt</td>
            <td>&euro; 12.372 (23,7%)</td>
            <td>&euro; 15.713 (57,1%)</td>
            <td>&euro; 26.008 (160%)</td>
          </tr>
          <tr :style="`color: ${tableColors[0]};`">
            <td>Slechte markt</td>
            <td>&euro; 8.957 (-10,4%)</td>
            <td>&euro; 9.951 (-0,49%)</td>
            <td>&euro; 13.632 (36,3%)</td>
          </tr>
          <tr>
            <td style="width:150px">Kans op negatief rendement</td>
            <td>13,9%</td>
            <td>5,18%</td>
            <td>0,75%</td>
          </tr>
        </table>

        <table
          v-if="intakeAdmin.beleggen.maxProfile === 'Doelbeleggen C'"
          class="transparent-table"
        >
          <tr>
            <th>{{ intakeAdmin.beleggen.maxProfile }}</th>
            <th>5 jaar</th>
            <th>10 jaar</th>
            <th>20 jaar</th>
          </tr>
          <tr :style="`color: ${tableColors[2]}`">
            <td>Goede markt</td>
            <td>&euro; 18.864 (88,6%)</td>
            <td>&euro; 28.871 (189%)</td>
            <td>&euro; 62.694 (527%)</td>
          </tr>
          <tr :style="`color: ${tableColors[1]}`">
            <td>Normale markt</td>
            <td>&euro; 12.770 (27,7%)</td>
            <td>&euro; 16.627 (66,3%)</td>
            <td>&euro; 28.728 (187%)</td>
          </tr>
          <tr :style="`color: ${tableColors[0]};`">
            <td>Slechte markt</td>
            <td>&euro; 8.644 (-13,6%)</td>
            <td>&euro; 9.575 (-4,25%)</td>
            <td>&euro; 13.164 (31,6%)</td>
          </tr>
          <tr>
            <td style="width:150px">Kans op negatief rendement</td>
            <td>15,1%</td>
            <td>6,48%</td>
            <td>1,31%</td>
          </tr>
        </table>

        <table
          v-if="intakeAdmin.beleggen.maxProfile === 'Doelbeleggen D'"
          class="transparent-table"
        >
          <tr>
            <th>{{ intakeAdmin.beleggen.maxProfile }}</th>
            <th>5 jaar</th>
            <th>10 jaar</th>
            <th>20 jaar</th>
          </tr>
          <tr :style="`color: ${tableColors[2]}`">
            <td>Goede markt</td>
            <td>&euro; 20.952 (110%)</td>
            <td>&euro; 33.884 (239%)</td>
            <td>&euro; 80.176 (702%)</td>
          </tr>
          <tr :style="`color: ${tableColors[1]}`">
            <td>Normale markt</td>
            <td>&euro; 13.178 (31,8%)</td>
            <td>&euro; 17.588 (75,9%)</td>
            <td>&euro; 31.718 (217%)</td>
          </tr>
          <tr :style="`color: ${tableColors[0]}`">
            <td>Slechte markt</td>
            <td>&euro; 8.289 (-17,1%)</td>
            <td>&euro; 9.129 (-8,71%)</td>
            <td>&euro; 12.548 (25,5%)</td>
          </tr>
          <tr>
            <td style="width:150px">Kans op negatief rendement</td>
            <td>16,4%</td>
            <td>7,83%</td>
            <td>2,03%</td>
          </tr>
        </table>

        <table
          v-if="intakeAdmin.beleggen.maxProfile === 'Doelbeleggen E'"
          class="transparent-table"
        >
          <tr>
            <th>{{ intakeAdmin.beleggen.maxProfile }}</th>
            <th>5 jaar</th>
            <th>10 jaar</th>
            <th>20 jaar</th>
          </tr>
          <tr :style="`color: ${tableColors[2]}`">
            <td>Goede markt</td>
            <td>&euro; 24.255 (142%)</td>
            <td>&euro; 42.254 (323%)</td>
            <td>&euro; 112.435 (1024%)</td>
          </tr>
          <tr :style="`color: ${tableColors[1]}`">
            <td>Normale markt</td>
            <td>&euro; 13.739 (37,4%)</td>
            <td>&euro; 18.947 (89,5%)</td>
            <td>&euro; 36.165 (262%)</td>
          </tr>
          <tr :style="`color: ${tableColors[0]};`">
            <td>Slechte markt</td>
            <td>&euro; 7.792 (-22,1%)</td>
            <td>&euro; 8.496 (-15,0%)</td>
            <td>&euro; 11.632 (16,3%)</td>
          </tr>
          <tr>
            <td style="width:150px">Kans op negatief rendement</td>
            <td>17,8%</td>
            <td>5,36%</td>
            <td>3,12%</td>
          </tr>
        </table>

        <table class="graph-table">
          <tr>
            <td colspan="4" class="chart">
              <GChart
                v-if="$parent.$parent.planToggle && lineRows"
                :settings="{ packages: ['corechart'], language: 'nl-nl' }"
                :data="[columns2].concat(lineRows)"
                :options="options2"
                type="LineChart"
              />
            </td>
          </tr>
        </table>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- samenstelling -->
    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />

        <p>
          U dient zich te realiseren dat zelfs bij een beleggingsbeleid met een laag risicoprofiel
          onvoorziene situaties tot gevolg kunnen hebben dat de waarde van uw portefeuille sterk
          negatief kan worden beïnvloed. Dit kunnen wij nooit uitsluiten. U kunt hierbij denken aan
          zaken als: faillissementen, terroristische aanslag, economische crisis of een
          impactvolle wetswijziging.
        </p>
        <p>
          Elk profiel bij Doelbeleggen kent een eigen verdeling tussen aandelen, vastgoed,
          obligaties en geldmarkt. Daarbij selecteren wij uit wereldwijde beleggingen. Al onze
          beleggingen zijn beursgenoteerd. Binnen obligaties belegt Doelbeleggen zowel in staats-
          als in bedrijfsobligaties. Uw beleggingsrekening werkt anders dan een gewone bankrekening.
          U kunt er niet voor langere tijd geld op hebben staan. Als u geld stort, wordt dat altijd
          meteen voor u belegd.
        </p>

        <h2>Spreiding en controle</h2>
        <p>
          Om een goed gespreide portefeuille samen te stellen, beleggen wij voor u in trackers.
          Trackers volgen een index en hebben daarom nagenoeg dezelfde spreiding. Tijdens het kiezen
          van de meest geschikte trackers (of ETF’s) wordt rekening gehouden met hun opzet. Ze
          werken niet allemaal hetzelfde.
        </p>
        <p>
          Bij Doelbeleggen beleggen wij in meerdere regio’s en sectoren. Om het risico te beperken,
          wordt bij het innemen van een positie gecontroleerd of dit niet tot een ongewenste
          disbalans in de risicospreiding van de beleggingsportefeuille leidt.
        </p>
        <p>
          Ook de verdeling die bij een bepaald profiel hoort, wordt door ons in de gaten gehouden.
          Het kan voorkomen dat een categorie (bijvoorbeeld aandelen) sneller in waarde daalt of
          stijgt dan een andere (bijvoorbeeld obligaties). Hierdoor kan de verdeling afwijken ten
          opzichte van de oorspronkelijke. Doelbeleggen zal wanneer nodig de verdeling van uw
          portefeuille terugbrengen binnen de oorspronkelijke bandbreedtes. Wij zoeken altijd naar
          het voor u optimale beleggingsbeleid met als beperking het
          <b>vastgestelde maximale beleggingsbeleid {{ intakeAdmin.beleggen.maxProfile }}</b
          >.
        </p>

        <h2>Samenstelling benchmarks</h2>
        <p>
          Om te zien hoe de waardeontwikkeling zich verhoudt tot de betreffende benchmark, hanteren
          wij voor iedere belegging binnen een beleggingscategorie een aparte benchmark.
        </p><br />

        <table class="new">
          <tr>
            <th style="vertical-align:top;">Aandelen</th>
            <td>
              VanEck Sustainable Global Equity Index<br />
              S&amp;P 500 ESG Exclusions II index<br />
              100% MSCI pacific ex Japan sri filtered index<br />
              MSCI USA Small Cap Index
            </td>
          </tr>
          <tr>
            <th>Vastgoed</th>
            <td>VanEck Global Real Estate Index</td>
          </tr>
          <tr>
            <th style="vertical-align:top;">Obligaties</th>
            <td>
              FTSE Advanced Climate Risk-Adjusted Eur Mon. Union Gov Bond Index<br />
              Barclays Euro Government Bond 1-3yr Term Index<br />
              Barclays Euro Government Inflation Linked Bond Index<br />
              Bloomberg MSCI Euro Corporate Sustainable SRI Index<br />
              Bloomberg MSCI Euro Corp Sustainable BBB+ SRI 0-3 Year Index
            </td>
          </tr>
          <tr>
            <th>Geldmarkt</th>
            <td>1M EUR LIBID + 5bp</td>
          </tr>
        </table>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- Duurzaamheids pagina -->
    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />
        <h2>Doelbeleggen en duurzaamheid</h2>
        <p>
          Hierbij geven wij u inzicht in hoe wij duurzaamheid hebben geïntegreerd in ons
          beleggingsproces.
          Op grond van de Sustainable Finance Disclosure Regulation (SFDR) geven wij informatie over
          duurzaamheid en beleggen.<br /><br />
          Wij bevorderen milieu- en/of sociale kenmerken, maar het beleggingsbeleid
          verbindt zich niet tot duurzame beleggingen in de zin van Verordening (EU) 2019/2088
          (‘SFDR’), noch tot het beleggen in economische activiteiten die volgens de
          Taxonomieverordening (EU 2020/852) als "ecologisch duurzaam" worden aangemerkt.
          <br /><br />
          Wij promoten ecologische of sociale kenmerken, maar heeft geen duurzame
          beleggingsdoelstelling. Wij streven dus naar een gezondere samenleving, een veiligere
          leefomgeving en een toekomstbestendige samenleving. Wij promoten dan ook sociale en
          ecologische kenmerken, waarbij wordt geborgd dat de fondsen waarin wordt belegd voldoen
          aan ‘good governance’.
        </p>
        <h3>EU-Taxonomie</h3>
        <p>
          De EU-Taxonomie omschrijft economische activiteiten die helpen bij het tegengaan van
          klimaatverandering of het beperken van de gevolgen ervan. Een belegging in een bedrijf dat
          deze activiteiten verricht, wordt als ecologisch duurzaam aangemerkt. Hier zijn
          verschillende criteria voor. Tegelijkertijd geldt als eis dat deze beleggingen geen
          afbreuk mogen doen aan andere duurzame doelstellingen. Dit wordt ook wel het
          ‘geen significante schade berokkenen aan’ beginsel genoemd.<br /><br />
          Er kunnen voor ons beleggingen zijn opgenomen, die bijdragen aan een milieudoelstelling.
          wij kunnen op dit moment niet beoordelen hoe en in welke mate deze beleggingen rekening
          houden met deze EU-criteria voor ecologisch duurzame economische activiteiten, maar geen
          afbreuk doen aan andere duurzame doelstellingen.
        </p>
        <h3>Duurzaamheidsrisico</h3>
        <p>
          Een duurzaamheidsrisico is het risico dat een belegging minder waard wordt als gevolg van
          een gebeurtenis of omstandigheid op het gebied van duurzaamheid.<br /><br />
          Voorbeelden van zulke gebeurtenissen of omstandigheden zijn klimaatverandering,
          betrokkenheid bij kinderarbeid, of schaarste aan grondstoffen. Zulke gebeurtenissen en
          omstandigheden kunnen een negatief effect hebben op de waarde van beleggingen. Zo kan
          grondstoffen schaarste ervoor zorgen dat bepaalde bedrijven minder kunnen produceren,
          waardoor aandelen in deze bedrijven in waarde kunnen verminderen.<br /><br />
          Wij beoordelen de mogelijke impact van duurzaamheidsrisico’s voor ons op
          eenzelfde manier als andere risico’s zoals bijvoorbeeld marktrisico’s. Al deze risico's
          resulteren niet alleen in de mogelijkheid dat het verwachte of beoogde doelvermogen niet
          wordt behaald, maar ook in tussentijdse of uiteindelijke verliezen.<br /><br />
          Bij iedere belegging kan zich in meer of mindere mate een duurzaamheidsrisico voordoen dat
          ervoor kan zorgen dat de waarde van een belegging kan dalen. Bij de selectie van een
          belegging voor ons baseren wij ons op de publiek bekende informatie en beoordelen wij het
          waarschijnlijke effect van alle risico’s op de beleggingen.<br /><br />
          Wij kunnen besluiten om bepaalde beleggingen niet op te nemen. Bijvoorbeeld wanneer al
          bekende duurzaamheidsrisico’s bestaan, die naar verwachting een grote negatieve invloed
          kunnen hebben op de waarde van de beleggingen.<br /><br />
        </p>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>
    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />
        <p>
          Als er hoge duurzaamheidsrisico's bij een belegging worden vaststelt, kunnen wij in
          overleg treden met de fondsmanager om de vastgestelde risico's te bespreken. Als de
          risico’s niet acceptabel zijn, kunnen wij  besluiten om de belegging te vervangen door een
          nieuwe belegging met lagere duurzaamheidsrisico's.<br /><br />
          De impact van duurzaamheidsrisico’s op het rendement van ons is afhankelijk van het type
          duurzaamheidsrisico dat zich verwezenlijkt in de gehele portefeuille van ons. Door de
          brede diversificatie van beleggingen in indexfondsen, zowel geografisch als tussen
          beleggingscategorieën verwachten wij dat een waardedaling als gevolg van dit type risico’s
          op de gehele portefeuille van ons beperkt is.
        </p>
        <h3>Ongunstige effecten op duurzaamheidsfactoren</h3>
        <p>
          Beleggingen kunnen ongunstige gevolgen hebben op duurzaamheidsfactoren. Zo kunnen
          beleggingen bijvoorbeeld in negatieve zin bijdragen aan klimaatverandering, corruptie
          of verlies van biodiversiteit.<br /><br />
          Wij beleggen alleen in breed gespreide indexfondsen/trackers waarvoor op dit moment
          onvoldoende informatie beschikbaar is om alle negatieve effecten van
          beleggingsbeslissingen zoals de duurzaamheidswetgeving dat voorschrijft te kunnen
          meewegen. Om deze reden houden wij bij het nemen van beleggingsbeslissingen (nog) geen
          rekening met alle mogelijke negatieve effecten op duurzaamheidsfactoren.<br /><br />
          Indien in de toekomst de beschikbaarheid van deze informatie verbetert zullen wij opnieuw
          beoordelen of wij alle negatieve effecten zoals voorgeschreven door de wet kunnen meewegen
          bij het nemen van onze beleggingsbeslissingen.
        </p>

      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>
    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />

        <!-- Kosten -->
        <h2>Kosten van dienstverlening en beleggen</h2>
        <p>
          U dient rekening te houden met het feit dat er kosten verbonden zijn aan het beleggen in
          effecten, zoals transactiekosten en kosten van trackers (of ETF's).
        </p>
        <p>
          Alle kosten, tarieven en vergoedingen zijn per jaar, inclusief eventuele BTW en
          worden per kwartaal in rekening gebracht.
        </p>
        <p>
          <b>Onze dienstverlening</b><br>
          Doelbeleggen heeft een vaste beheervergoeding (Doorlopend) van 0,75% per jaar. Deze wordt
          per kwartaal in rekening gebracht. Daarnaast wordt een vergoeding van 0,10% over de
          transactiewaarde van een aan- of verkoop gerekend (Transacties). In lopende jaren komen
          deze door herwegen en optimaliseren van de portefeuille neer op circa 0,02% per jaar.
          Bij het vermogensbeheer moeten we ook vergoedingen betalen aan anderen (Verwante
          diensten), zoals de kosten van toezichthouders (AFM en DNB) of eventuele belasting over
          transacties. Deze kosten berekenen wij aan u door en zijn 0,01% over het belegd vermogen.
        </p>
        <p>
          <b>Financiële instrumenten</b><br>
          We beleggen voor u in trackers. Wij ontwikkelen zelf geen trackers. Dat doen andere
          bedrijven. De kosten van deze bedrijven zitten in de koers van de trackers. Deze bestaan
          uit een management fee (Doorlopend) en transactie&shy;kosten (Transacties).
          U ziet deze kosten ook niet. Wij ook niet. Deze kosten zijn gemiddeld over de
          verschillende profielen, circa {{ formatPrice(simpleVKM.instruments.totalPercent()) }}%
          per jaar.
        </p>

        <br>

        <table class="new" v-if="intake.goalData.vermogen > 9">
          <tr>
            <td><b>Inleg: &euro; {{ formatPrice(simpleVKM.startAmount) }}</b></td>
            <td></td>
            <td><b>Jaar 1</b></td>
            <td></td>
            <td><b>Volgende jaren</b></td>
          </tr>
          <tr>
            <th>Onze dienstverlening</th>
            <th>
              &euro; {{
                  formatPrice(simpleVKM.services.continuousCost()
                  + simpleVKM.services.transactionsCostYear1()
                  + simpleVKM.services.servicesCost())
                }}
            </th>
            <th>{{ formatPrice(simpleVKM.services.totalPercentYear1()) }}%</th>
            <th>
              &euro; {{
                  formatPrice(simpleVKM.services.continuousCost()
                  + simpleVKM.services.transactionsCost()
                  + simpleVKM.services.servicesCost())
                }}
            </th>
            <th>{{ formatPrice(simpleVKM.services.totalPercent()) }}%</th>
          </tr>
          <tr>
            <td>Doorlopend</td>
            <td>&euro; {{ formatPrice(simpleVKM.services.continuousCost()) }}</td>
            <td>{{ formatPrice(simpleVKM.services.continuousPercent) }}%</td>
            <td>&euro; {{ formatPrice(simpleVKM.services.continuousCost()) }}</td>
            <td>{{ formatPrice(simpleVKM.services.continuousPercent) }}%</td>
          </tr>
          <tr>
            <td>Transacties</td>
            <td>&euro; {{ formatPrice(simpleVKM.services.transactionsCostYear1()) }}</td>
            <td>{{formatPrice(simpleVKM.services.transactionsPercentYear1)}}%</td>
            <td>&euro; {{ formatPrice(simpleVKM.services.transactionsCost()) }}</td>
            <td>{{formatPrice(simpleVKM.services.transactionsPercent)}}%</td>
          </tr>
          <tr>
            <td>Verwante diensten</td>
            <td>&euro; {{ formatPrice(simpleVKM.services.servicesCost()) }}</td>
            <td>{{formatPrice(simpleVKM.services.servicesPercent)}}%</td>
            <td>&euro; {{ formatPrice(simpleVKM.services.servicesCost()) }}</td>
            <td>{{formatPrice(simpleVKM.services.servicesPercent)}}%</td>
          </tr>
          <tr v-if="hasExcasso">
            <td>Uitvoering excasso</td>
            <td>&euro; {{formatPrice(simpleVKM.services.excassoCost)}}</td>
            <td>{{formatPrice(simpleVKM.services.excassoPercent)}}%</td>
            <td>&euro; {{formatPrice(simpleVKM.services.excassoCost)}}</td>
            <td>{{formatPrice(simpleVKM.services.excassoPercent)}}%</td>
          </tr>
          <tr>
            <th>Financiële instrumenten</th>
            <th>
              &euro; {{ formatPrice(simpleVKM.instruments.continuousCost()
              + simpleVKM.instruments.transactionsCost()) }}
            </th>
            <th>{{ formatPrice(simpleVKM.instruments.totalPercent()) }}%</th>
            <th>
              &euro; {{ formatPrice(simpleVKM.instruments.continuousCost()
              + simpleVKM.instruments.transactionsCost()) }}
            </th>
            <th>{{ formatPrice(simpleVKM.instruments.totalPercent()) }}%</th>
          </tr>
          <tr>
            <td>Doorlopend</td>
            <td>&euro; {{ formatPrice(simpleVKM.instruments.continuousCost()) }}</td>
            <td>{{formatPrice(simpleVKM.instruments.continuousPercent)}}%</td>
            <td>&euro; {{ formatPrice(simpleVKM.instruments.continuousCost()) }}</td>
            <td>{{formatPrice(simpleVKM.instruments.continuousPercent)}}%</td>
          </tr>
          <tr>
            <td>Transacties</td>
            <td>&euro; {{ formatPrice(simpleVKM.instruments.transactionsCost()) }}</td>
            <td>{{formatPrice(simpleVKM.instruments.transactionsPercent)}}%</td>
            <td>&euro; {{ formatPrice(simpleVKM.instruments.transactionsCost()) }}</td>
            <td>{{formatPrice(simpleVKM.instruments.transactionsPercent)}}%</td>
          </tr>
          <tr>
            <th>Totaal</th>
            <th>&euro; {{ formatPrice(simpleVKM.totalCostYear1()) }}</th>
            <th>{{ formatPrice(simpleVKM.totalPercentYear1()) }}%</th>
            <th>&euro; {{ formatPrice(simpleVKM.totalCost()) }}</th>
            <th>{{ formatPrice(simpleVKM.totalPercent()) }}%</th>
          </tr>
        </table>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- Overige opmerkingen -->
    <div
      class="card"
      v-if="
        intakeAdmin.publicNote
        || (
          intake.atpData
          && intake.atpData.connected
          && (
            intakeAdmin.beleggen.feeName === 'dbatpopbouwend'
            || intakeAdmin.beleggen.feeName === 'dbatpuitkerend'
          )
        )
      "
    >
      <div class="print">
        <img class="db-logo" src="../../assets/db/DB-logo1.svg" />

        <template
          v-if="
            intake.atpData
            && intake.atpData.connected
            && (
              intakeAdmin.beleggen.feeName === 'dbatpopbouwend'
              || intakeAdmin.beleggen.feeName === 'dbatpuitkerend'
            )
          "
        >
          <h2>Aanvullend</h2>
          <p>
            Voor u is in overleg met uw adviseur afgesproken dat de kosten voor onze dienstverlening
            worden vervangen door één vaste all-in vergoeding van
            {{
              intakeAdmin.beleggen.feeName === 'dbatpopbouwend'
                ? '0,65%'
                : '0,75%'
            }} per jaar.
          </p>
        </template>
        <template v-if="intakeAdmin.publicNote">
          <h2>Overige opmerkingen</h2>
          <div class="msg">
            {{intakeAdmin.publicNote}}
          </div>
        </template>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@doelbeleggen.nl –
        020&nbsp;555&nbsp;0055 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>
  </div>
</template>

<script>
import { sumBy, filter } from 'lodash-es';
import scoreWidget from '../ui/scoreMeter';

export default {
  components: {
    scoreWidget,
  },
  props: {
    intake: Object,
    intakeAdmin: Object,
    today: Date,
    redo: {
      default: -1,
      type: Number,
    },
    portValue: {
      default: -1,
      type: Number,
    },
    id: Number,
  },
  data() {
    return {
      tableColors: ['#c1272d', '#006', '#6c0'],
      options1: {
        pieHole: 0.4,
        colors: ['#6c0', '#006', '#f34b0a', '#3e7904', '#ccc'],
        chartArea: {
          left: 20,
          top: 20,
          bottom: 20,
          right: 50,
          width: '100%',
        },
        backgroundColor: {
          fillOpacity: 0,
        },
        pieSliceTextStyle: {
          color: 'black',
        },
      },
      columns1: [
        {
          type: 'string',
          label: 'Type',
        },
        {
          type: 'number',
          label: '%',
        },
      ],
      options2: {
        colors: ['#c1272d', '#006', '#6c0'],
        pointSize: 5,
        chartArea: {
          left: 50,
          right: 0,
          top: 5,
          bottom: 20,
          width: '100%',
          height: '100%',
        },
        height: 200,
        width: 600,
        curveType: 'function',
        backgroundColor: {
          fillOpacity: 0,
        },
      },
      columns2: [
        {
          type: 'string',
          label: 'Jaar',
        },
        {
          type: 'number',
          label: 'Slechte Markt',
        },
        {
          type: 'number',
          label: 'Normale Markt',
        },
        {
          type: 'number',
          label: 'Goede Markt',
        },
      ],
    };
  },
  computed: {
    goalType() {
      if (
        (
          this.intake.goalData.type === 'levensonderhoud'
          && this.intake.goalData.box === '1'
        )
        || this.intake.goalData.type === 'netto-lijfrente-uitkerend'
        || this.intake.goalData.type === 'gouden-handdruk-uitkerend'
      ) {
        return 'uitkerend';
      }
      return 'opbouwend';
    },
    sustainabilityPopup() {
      if (this.intake.rekeningData.sustainabilityNew) {
        if (this.intake.rekeningData.sustainabilityNew === 'Nee') {
          return 'A';
        }
        if (
          this.intake.rekeningData.sustainabilityNew === 'Ja, niet specifiek'
          || (
            this.intake.rekeningData.sustainabilityEcologicPreference === 'Nee'
            && this.intake.rekeningData.sustainabilityEffect
            && this.intake.rekeningData.sustainabilityEffect !== 'Ja, PAI'
          )
          || (
            this.intake.rekeningData.sustainabilityEcologicPreference === 'Nee'
            && this.intake.rekeningData.sustainabilityEffect === 'Ja, PAI'
            && this.intake.rekeningData.sustainabilityPaiConsider === 'Geen'
          )
        ) {
          return 'B';
        }
        if (this.intake.rekeningData.sustainabilityNew === 'Ja, specifiek') {
          if (
            (
              this.intake.rekeningData.sustainabilityEcologicPreference
              && this.intake.rekeningData.sustainabilityEcologicPreference !== 'Nee'
            )
            || (
              this.intake.rekeningData.sustainabilityEcologicPreference === 'Nee'
              && this.intake.rekeningData.sustainabilityEffect === 'Ja, PAI'
              && this.intake.rekeningData.sustainabilityPaiConsider
              && this.intake.rekeningData.sustainabilityPaiConsider !== 'Geen'
            )
          ) {
            return 'C';
          }
        }
      }
      return '';
    },
    typeToGoal() {
      if (this.intake.goalData.type === 'studiekinderen') {
        return 'studie kinderen';
      }
      if (this.intake.goalData.type === 'groteaankoop') {
        return 'grote aankoop';
      }
      if (this.intake.goalData.type === 'gouden-handdruk-opbouwend') {
        return 'gouden handdruk (opbouwend)';
      }
      if (this.intake.goalData.type === 'gouden-handdruk-uitkerend') {
        return 'gouden handdruk (uitkerend)';
      }
      if (this.intake.goalData.type === 'netto-lijfrente-opbouwend') {
        return 'Netto lijfrente (opbouwend)';
      }
      if (this.intake.goalData.type === 'netto-lijfrente-uitkerend') {
        return 'Netto lijfrente (uitkerend)';
      }
      if (this.intake.goalData.type === 'pensioen' && this.intake.goalData.box === '1') {
        return 'pensioen (box 1)';
      }
      if (this.intake.goalData.type === 'levensonderhoud' && this.intake.goalData.box === '1') {
        return 'leefrente (box 1)';
      }
      return this.intake.goalData.type;
    },
    paymentTerms() {
      if (this.intake.goalData.stortingenInterval === 'Per maand') {
        return 12;
      }
      if (this.intake.goalData.stortingenInterval === 'Per kwartaal') {
        return 4;
      }
      if (this.intake.goalData.stortingenInterval === 'Per halfjaar') {
        return 2;
      }
      return 1;
    },
    hasExcasso() {
      if (this.intake.goalData.type === 'gouden-handdruk-uitkerend'
        || this.intake.goalData.type === 'netto-lijfrente-uitkerend'
        || (this.intake.goalData.type === 'levensonderhoud' && this.intake.goalData.box === '1')) {
        return true;
      }
      return false;
    },
    simpleVKM() {
      const amount = Number(this.intake.goalData.vermogen);
      let excassoPercentage = 0.0025;
      if (this.intakeAdmin.beleggen && this.intakeAdmin.beleggen.feeName === 'dbuitkerendgeeneu') {
        excassoPercentage = 0.0050;
      }
      const excasso = this.hasExcasso ? amount * excassoPercentage + (4.5 * this.paymentTerms) : 0;
      const vkm = {
        startAmount: amount,
        totalCost() {
          return this.services.totalCost() + this.instruments.totalCost();
        },
        totalCostYear1() {
          return this.services.totalCostYear1() + this.instruments.totalCost();
        },
        totalPercentYear1() {
          return this.services.totalPercentYear1() + this.instruments.totalPercent();
        },
        totalPercent() {
          return this.services.totalPercent() + this.instruments.totalPercent();
        },
        services: {
          continuousPercent: 0.75,
          continuousCost() {
            return amount * (this.continuousPercent / 100);
          },
          transactionsPercentYear1: 0.22,
          transactionsCostYear1() {
            return amount * (this.transactionsPercentYear1 / 100);
          },
          transactionsPercent: 0.02,
          transactionsCost() {
            return amount * (this.transactionsPercent / 100);
          },
          servicesPercent: 0.01,
          servicesCost() {
            return amount * (this.servicesPercent / 100);
          },
          excassoCost: excasso,
          excassoPercent: (excasso / amount) * 100,
          totalCostYear1() {
            return this.continuousCost()
              + this.transactionsCostYear1()
              + this.servicesCost()
              + this.excassoCost;
          },
          totalCost() {
            return this.continuousCost()
              + this.transactionsCost()
              + this.servicesCost()
              + this.excassoCost;
          },
          totalPercentYear1() {
            return this.continuousPercent
            + this.transactionsPercentYear1
            + this.servicesPercent
            + this.excassoPercent;
          },
          totalPercent() {
            return this.continuousPercent
            + this.transactionsPercent
            + this.servicesPercent
            + this.excassoPercent;
          },
        },
        instruments: {
          continuousPercent: 0.17,
          continuousCost() {
            return amount * (this.continuousPercent / 100);
          },
          transactionsPercent: 0.02,
          transactionsCost() {
            return amount * (this.transactionsPercent / 100);
          },
          totalPercent() {
            return this.continuousPercent + this.transactionsPercent;
          },
          totalCost() {
            return this.continuousCost() + this.transactionsCost();
          },
        },
      };
      return vkm;
    },
    totalBezit() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        (o) => Number(o.spaarrekeningBedrag || 0)
          + Number(o.spaarrekeningBedrag2 || 0)
          + Number(o.spaarrekeningBedrag3 || 0)
          // beleggingen
          + Number(o.beleggingenBedrag || 0)
          + Number(o.beleggingenMeerBedrag || 0)
          + Number(o.beleggingenNogMeerBedrag || 0)
          // verkoopwaarde eigenwoning niet mee rekenen!
          // verkoopwaarde onroerendgoed
          + Number(o.onroerendgoedVrijeverkoopwaarde || 0),
      );
    },
    pieRows() {
      if (this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen A') {
        return [
          ['Aandelen', 15],
          ['Vastgoed', 5],
          ['Obligaties', 75],
          ['Geldmarkt', 5],
        ];
      }
      if (this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen B') {
        return [
          ['Aandelen', 35],
          ['Vastgoed', 5],
          ['Obligaties', 55],
          ['Geldmarkt', 5],
        ];
      }
      if (this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen C') {
        return [
          ['Aandelen', 50],
          ['Vastgoed', 5],
          ['Obligaties', 40],
          ['Geldmarkt', 5],
        ];
      }
      if (this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen D') {
        return [
          ['Aandelen', 65],
          ['Vastgoed', 5],
          ['Obligaties', 25],
          ['Geldmarkt', 5],
        ];
      }
      if (this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen E') {
        return [
          ['Aandelen', 85],
          ['Vastgoed', 5],
          ['Obligaties', 5],
          ['Geldmarkt', 5],
        ];
      }
      return false;
    },
    lineRows() {
      if (this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen A') {
        return [
          ['5 jaar', 9216, 11856, 15253],
          ['10 jaar', 10199, 14565, 20799],
          ['20 jaar', 13750, 22758, 37667],
        ];
      }
      if (this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen B') {
        return [
          ['5 jaar', 8957, 12372, 17088],
          ['10 jaar', 9951, 15713, 24810],
          ['20 jaar', 13632, 26008, 49619],
        ];
      }
      if (this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen C') {
        return [
          ['5 jaar', 8644, 12770, 18864],
          ['10 jaar', 9575, 16627, 28871],
          ['20 jaar', 13164, 28728, 62694],
        ];
      }
      if (this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen D') {
        return [
          ['5 jaar', 8289, 13178, 20952],
          ['10 jaar', 9129, 17588, 33884],
          ['20 jaar', 12548, 31718, 80176],
        ];
      }
      if (this.intakeAdmin.beleggen.maxProfile === 'Doelbeleggen E') {
        return [
          ['5 jaar', 7792, 13739, 24255],
          ['10 jaar', 8496, 18947, 42254],
          ['20 jaar', 11632, 36165, 112435],
        ];
      }
      return false;
    },
    offerSelected() {
      let selectedOffer = [];
      if (this.intake.goalData.type === 'netto-lijfrente-uitkerend') {
        selectedOffer = filter(
          this.intake.offers,
          (o) => (o.offerType === '4' || o.offerType === '5') && o.selected,
        );
      } else if (this.intake.goalData.type === 'gouden-handdruk-uitkerend') {
        selectedOffer = filter(
          this.intake.offers,
          (o) => (o.offerType === '2' || o.offerType === '3') && o.selected,
        );
      } else {
        selectedOffer = filter(
          this.intake.offers,
          (o) => (o.offerType === '0' || o.offerType === '1') && o.selected,
        );
      }
      if (selectedOffer[0]) {
        return Object.assign(
          selectedOffer[0],
          this.intakeAdmin.offers[selectedOffer[0].offerId],
        );
      }
      return selectedOffer[0];
    },
  },
  methods: {
    sumBy,
    filter,
    financeFilter(o) {
      if (this.intake.rekeningData.type === 'Minderjarige rekening' && o.type !== 'Minderjarige') {
        return true;
      }
      if (this.intake.rekeningData.type === 'Particuliere rekening' && o.type !== 'Volmacht') {
        return true;
      }
      if (this.intake.rekeningData.type === 'Bedrijfsrekening' && o.type !== 'Volmacht') {
        return true;
      }
      return false;
    },
    deathFilter(o) {
      return !o.sterfteDatum;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/_paper.scss";
.transparent-table {
  tr {
    background-color: transparent;
  }
}

.new {
  img {
    width: 80%;
  }
}

.graph-table {
    tr {
      border-top: none;
      background-color: transparent;
      td:first-of-type {
        font-weight: bold;
      }
    }
  }
.maxprofile-DoelbeleggenA {
  td,
  th {
    &:nth-child(n + 3) {
      display: none;
    }
  }
}
.maxprofile-DoelbeleggenB {
  td,
  th {
    &:nth-child(n + 4) {
      display: none;
    }
  }
}
.maxprofile-DoelbeleggenC {
  td,
  th {
    &:nth-child(n + 5) {
      display: none;
    }
  }
}
.maxprofile-DoelbeleggenD {
  td,
  th {
    &:nth-child(n + 6) {
      display: none;
    }
  }
}
.profile-DoelbeleggenA {
  td:nth-child(2) {
    font-weight: 600;
    background-color: #e7eaf0;
  }
}
.profile-DoelbeleggenB {
  td:nth-child(3) {
    font-weight: 600;
    background-color: #e7eaf0;
  }
}
.profile-DoelbeleggenC {
  td:nth-child(4) {
    font-weight: 600;
    background-color: #e7eaf0;
  }
}
.profile-DoelbeleggenD {
  td:nth-child(5) {
    font-weight: 600;
    background-color: #e7eaf0;
  }
}
.profile-DoelbeleggenE {
  td:nth-child(6) {
    font-weight: 600;
    background-color: #e7eaf0;
  }
}
.box {
  padding: 20px;
}
h2 {
  margin-top: 30px;
  &:first-child {
    margin-top: 0;
  }
}
mark {
  display: block;
}
.tablehead {
  background-color: #e9ecf2;
}
.scroll-container {
  width: 100%;
  overflow: auto;
}
</style>

<!-- modal print -->
<style lang="scss">
@media print {
  #showstoppers,
  #accountstatus,
  .steps,
  .announcement {
    display: none;
  }
  #mainview {
    padding: 0 !important;
  }
  .modal-background {
    position: relative !important;
    .modal {
      transform: unset !important;
      width: unset !important;
      position: relative !important;
      top: initial !important;
      left: initial !important;
      background-color: white;
      max-width: unset !important;
      .title-bar,
      .footer {
        display: none;
      }
      .viewport {
        height: unset !important;
        width: unset !important;
        position: relative !important;
        padding: 0 !important;
        top: 0 !important;
        overflow: hidden;
        > * {
          width: unset !important;
          height: unset !important;
        }
      }
    }
  }
}
</style>
